import Vue from 'vue'

Vue.directive('lazy-load', {
  inserted: function (el, binding) {
    var loader = document.createElement('div')
    loader.classList.add('loader')

    el.parentNode.appendChild(loader)
    el.classList.add('loading')
    el.setAttribute('src', binding.value)
    el.onload = function () {
      setTimeout(function () {
        loader.classList.add('hide')
        el.classList.remove('loading')
      }, 200)
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/lazy-load.js